module.exports = __webpack_public_path__ + "media/Zeitzeugen_Trailer_v01.68c54585.mp4";